import {
  Box,
  Divider,
  Grid2,
  Typography,
  Link,
  SvgIcon,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { useTranslation } from "react-i18next";

function Page({ title, icon, links, children }: any) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <SvgIcon sx={{ fontSize: 50, marginRight: 1 }}>{icon}</SvgIcon>
        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              ...(isMobile && { width: "270px" }),
            }}
          >
            {t("welcome")} <span style={{ color: "red" }}>MyCareFlex</span>
          </Typography>
          <Typography variant="subtitle2">{t(title)}</Typography>
        </Box>
      </Box>

      <Divider sx={{ marginTop: 2 }} />

      <Box sx={{ marginTop: 2 }}>{children}</Box>

      <Grid2 container justifyContent="space-between" sx={{ marginTop: 3 }}>
        {links &&
          links.map((link: any, i: number) => (
            <Link
              key={i}
              component={RouterLink}
              to={link.url}
              sx={{ color: "primary" }}
              underline="hover"
            >
              {t(link.label)}
            </Link>
          ))}
      </Grid2>
    </Box>
  );
}

export default Page;
